import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../layout/header/header.component';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
import { LoadingService } from '../../service/loading.service';
import { AuthenticationService } from '../../service/authentication.service';
import { VendorInformationChangeRequestService } from '../../service/vendor-information-change-request.service';
import _ from 'lodash';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    HeaderComponent,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  prefixLabel: string = '';
  readonly clientId!: string;
  readonly id!: string;

  Visible: boolean = false;
  showInvoiceWarning: boolean = false;
  private returnUrl: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private spinner: LoadingService,
    private formBuilder: FormBuilder,
    private userloginservice: AuthenticationService,
    private VendorInformationChangeRequestService: VendorInformationChangeRequestService,
  ) {
    this.form = this.formBuilder.group({
      VendorId: ['00000000-0000-0000-0000-000000000000'],
      Email: [null, [Validators.email, Validators.required]],
      Password: [null, Validators.required],
    });
  }

  ngOnInit() {
    // Check if user was redirected from invoice pages
    this.route.queryParams.subscribe((params) => {
      if (params['from'] === 'invoice' || params['redirect'] === 'invoice') {
        this.showInvoiceWarning = true;
      }
      this.returnUrl = this.sanitizeReturnUrl(params['returnUrl']);
    });
  }

  private sanitizeReturnUrl(candidate: unknown): string | null {
    if (typeof candidate !== 'string' || candidate.trim().length === 0) {
      return null;
    }

    const target = candidate.trim();
    if (!target.startsWith('/') || target.startsWith('//')) {
      return null;
    }

    return target.startsWith('/login') ? null : target;
  }

  private landingUrlAfterLogin(): string {
    return this.returnUrl ?? 'profile';
  }

  onLogin() {
    this.submitted = true;
    if (this.form.invalid) {
      this.utilityService.getFormValidationErrors(this.form);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }
    let request = _.cloneDeep(this.form.value);
    let requestCall;
    this.spinner.OnLoading.emit(true);
    requestCall = this.userloginservice.login(request, this.prefixLabel);
    requestCall.subscribe(
      (data: any) => {
        localStorage.setItem('token', data.token);
        requestCall = this.VendorInformationChangeRequestService.getForm(
          data.vendorId,
        );
        requestCall.subscribe(
          (vendorData: any) => {
            this.spinner.OnLoading.emit(false);
            if (!vendorData) {
              Swal.fire({
                icon: 'warning',
                title: 'Access Issue',
                text: 'Unable to retrieve vendor information. Please contact admin for assistance.',
              });
              return;
            }
            localStorage.setItem('userEmail', JSON.stringify(data.email));
            localStorage.setItem('token', data.token);
            localStorage.setItem('vendorId', JSON.stringify(data.vendorId));
            localStorage.setItem('login', JSON.stringify(true));
            // Keep only what the portal screens read back. The full vendor form
            // carries bank and tax values that must not sit in the browser.
            localStorage.setItem(
              'registrationData',
              JSON.stringify({
                id: vendorData.id,
                name: vendorData.name,
                address: vendorData.address,
              }),
            );
            localStorage.setItem(
              'vendorNumber',
              JSON.stringify(vendorData.vendorNumber),
            );
            this.router.navigateByUrl(this.landingUrlAfterLogin());
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Login successful',
            }).then(() => {
              window.location.reload();
            });
          },
          (err: any) => {
            this.spinner.OnLoading.emit(false);
            localStorage.setItem('token', JSON.stringify(''));
            localStorage.setItem('vendorId', JSON.stringify(''));
            localStorage.setItem('login', JSON.stringify(false));
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: 'Unable to retrieve vendor information. Please contact admin for assistance.',
            });
          },
        );
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.notificationService.showError(
          'Invalid email or password!',
          'Error',
        );
      },
    );
  }

  toggleVisibility(): void {
    this.Visible = !this.Visible;
  }
  get f() {
    return this.form.controls;
  }
}
